export const tags = (t) => [
    {
        id: 'manual',
        label: t('ai_tracking.prompt_generator.tags.manual'),
    },
    {
        id: 'google_search_console',
        label: t('ai_tracking.prompt_generator.tags.google_search_console'),
    },
    {
        id: 'brand_to_entities_to_prompts',
        label: t('ai_tracking.prompt_generator.tags.brand_to_entities_to_prompts'),
    },
    { id: 'entities', label: t('ai_tracking.prompt_generator.tags.entities') },
    {
        id: 'existing_prompts',
        label: t('ai_tracking.prompt_generator.tags.existing_prompts'),
    },
];
